<template>
    <!--    <div id="filter" v-if="filter" class="border rounded p-3 mt-6">-->

    <!--        <div>-->
    <!--            <div v-if="filter.checked==0" class="text-sm text-gray-100 bg-gray-600 rounded-lg  p-1 mb-4 text-center font-medium cursor-pointer focus:outline-none hover:shadow-outline">-->
    <!--                <span>{{translate('filter')}}</span>-->

    <!--            </div>-->
    <!--            <div v-else class="text-sm text-gray-100 bg-gray-600 rounded-lg  p-1 mb-4 text-center font-medium cursor-pointer focus:outline-none hover:shadow-outline" @click="filterReset">-->
    <!--                <span>{{translate('filter_reset')}}</span>-->
    <!--            </div>-->
    <!--            <div class="mb-4">{{translate('product_selected')}} <b>{{filter.product_count_all}}</b></div>-->
    <!--        </div>-->
    <!--        <div class="mb-8" v-for="group in filter.groups">-->
    <!--            <div class="bg-gray-100 flex justify-between content-center mb-3 p-1 cursor-pointer"-->
    <!--                 @click="group.open = !group.open">-->
    <!--                <div id="brand_title" class="text-base font-semibold  " title="свернуть"-->
    <!--                     v-text="group.title.capitalize()"></div>-->
    <!--                <div v-show="!group.open" class="text-gray-800 text-lg transform rotate-90">></div>-->
    <!--                <div v-show="group.open" class="text-gray-800 text-lg transform -rotate-90 cursor-pointer">></div>-->
    <!--            </div>-->
    <!--            <div v-show="group.open" v-for="item in group.items" class="mb-1 focus:outline-none hover:text-gray-900">-->
    <!--                <div v-if="item.product_count > 0">-->
    <!--                    <input name="aaa" value="415" type="checkbox" v-model="item.checked" :id="'checkbox_'+item.id"-->
    <!--                           class="mr-1  " @change="toggle(item,group)" :disabled="item.product_count == 0"-->
    <!--                           :class="{'cursor-pointer':item.product_count > 0}">-->
    <!--                    <label :for="'checkbox_'+item.id" class="  " v-text="item.title.capitalize()+' ('+item.product_count+')'" :class="{'cursor-pointer':item.product_count > 0, 'italic':item.product_count == 0}"></label>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--    </div>-->
    <div>
        <div class="tw-text-lg tw-text-black tw-font-medium d-md-none" @click="filter_visible = !filter_visible" tabindex="-1">
            <i class="fa fa-filter d-md-none mr-2 my-3" ></i>
            <span>{{translate('filter')}}</span>
        </div>
        <div class="d-none d-md-block" :class="filter_visible?'d-block':'d-none'" >
            <!--TOOLS-->
            <div v-if="filter.checked==0 && filter.priceRangeChange==0"
                 class="tw-text-lg tw-text-black tw-font-medium d-none d-md-block">
                <span>{{translate('filter')}}</span>
            </div>
            <div v-else
                 class="tw-text-sm tw-text-gray-100 tw-bg-gray-600 tw-rounded-lg  tw-p-1 tw-mb-4 tw-text-center tw-font-medium tw-cursor-pointer tw-focus:outline-none hover:tw-shadow-outline"
                 @click="filterReset">
                <span>{{translate('filter_reset')}}</span>
            </div>

            <div><span>{{translate('product_selected')}}: </span><span class="products_count">{{filter.product_count_all}}</span></div>

            <!--PRICE-->

            <div class="sidebar_section filter_by_section">
                <div class="sidebar_subtitle">{{translate('price')}}</div>
                <div class="filter_price1">
                    <!--                <div id="slider-range" class="slider_range"></div>-->
                    <!--                <p>Range: </p>-->
                    <!--                <p><input type="text" id="amount" class="amount" readonly style="border:0; font-weight:bold;"></p>-->
                    <price-range :priceRangeInitial="filter.price_range_initial" :priceRangeCurrent="filter.price_range_current"
                                 @rangeChange="rangeChange"></price-range>
                </div>
            </div>

            <!--GROUPS-->
            <div class="sidebar_section" v-for="group in filter.groups">
                <div class="sidebar_subtitle brands_subtitle">{{group.title}}</div>
                <ul class="brands_list">
                    <li v-for="(item,index) in even(group)" :key="item.id"
                        v-if="item.products_count > 0 && (index<filter_items_limit || group.open)">
                        <input value="415" type="checkbox" :id="group.title+'_'+item.id"
                               v-model="item.checked"
                               @change="toggle(item,group)"
                               class="mr-1  tw-cursor-pointer">
                        <label :for="group.title+'_'+item.id" class=" tw-cursor-pointer">{{item.title}}
                            <i>({{item.products_count}})</i>
                        </label>
                    </li>
                    <a href="#" class="tw-border-b tw-border-dashed tw-text-blue-400"
                       v-if="withProducts(group) > filter_items_limit" @click.prevent="group.open = !group.open">
                        <span v-if="!group.open">{{translate('filter_show_all')}}</span>
                        <span v-else>{{translate('filter_hide')}}</span>
                    </a>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1)
    };
    export default {
        props: ['filter_data', 'locale'],
        data() {
            return {
                filter: {},
                filter_visible: false,
                trans: {
                    'filter': {
                        'ru': 'Фильтры',
                        'uk': 'Фільтри',
                    },
                    'filter_reset': {
                        'ru': 'Сбросить фильтр',
                        'uk': 'Скинути фільтр',
                    },
                    'filter_show_all': {
                        'ru': 'Показать все',
                        'uk': 'Показати все',
                    },
                    'filter_hide': {
                        'ru': 'Свернуть',
                        'uk': 'Згорнути',
                    },
                    'product_selected': {
                        'ru': 'Найдено товаров',
                        'uk': 'Знайдено товарів',
                    },
                    'price': {
                        'ru': 'Цена',
                        'uk': 'Ціна',
                    },
                },
                filter_items_limit: 5,
            }
        },
        created() {
            this.filter = JSON.parse(this.filter_data);
        },
        mounted() {

        },
        methods: {
            translate(sentence) {
                return this.trans[sentence][this.locale];
            },

            even: function (arr) {
                if (arr.open || arr.items.length <= this.filter_items_limit) {
                    return arr.items;
                }
                return arr.items.slice().sort(function (a, b) {
                    return b.products_count - a.products_count;
                });
            },

            withProducts(group) {
                let items_count = group.items.filter(item => {
                    return item.products_count > 0
                });
                return items_count.length;
            },

            refineFilter() {
                if (history.pushState) {
                    let newurl = window.location.href.split('?')[0];
                    window.history.pushState({path:newurl},'',newurl);
                }
                axios
                    .post(window.location.href.split('?')[0], {
                        'filter': this.filter,
                    })
                    .then(response => {
                        EventBus.$emit('resetPageNumber',response.data.last_page);
                        this.filter = response.data.filter;
                        $('#products').html(response.data.products);
                    })
                    .catch();
            },

            toggle(item, group) {
                item.checked ? this.filter.checked++ : this.filter.checked--;
                group.current = true;
                this.filter.priceRangeChange=0;
                this.refineFilter();
            },

            filterReset() {
                this.filter.groups.forEach(group => {
                    group.items.forEach(item => {
                        item.checked = false
                    });
                });
                this.filter.checked = 0;
                this.filter.priceRangeChange=0;
                this.filter.price_range_current= this.filter.price_range_initial;
                this.refineFilter();
            },

            rangeChange(data) {
                this.filter.price_range_current.min = data.min;
                this.filter.price_range_current.max = data.max;
                // this.filter.checked=1;
                this.filter.priceRangeChange=1;
                this.refineFilter();
            },

        },

    }

</script>

<style scoped>
    /*input:disabled+label {*/
    /*    color: #ccc;*/
    /*}*/
    .products_count{
        color: #0e8ce4;
        font-weight: bold;
    }
</style>
